import PropTypes from 'prop-types';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Button, Container, CardMedia, Divider, Stack, Grid, Link, Typography } from '@mui/material';

// third party
import { motion } from 'framer-motion';

// project import
import { ThemeDirection, ThemeMode } from '../../config';
import useConfig from '../../hooks/useConfig';

// assets
import { SendOutlined } from '@ant-design/icons';
import imgfooterlogo from '../../assets/landing/PassionIT-green-p-200.jpeg';
// import imgfootersoc1 from 'assets/images/landing/img-soc1.svg';
// import imgfootersoc2 from 'assets/images/landing/img-soc2.svg';
// import imgfootersoc3 from 'assets/images/landing/img-soc3.svg';
import AnimateButton from '../../Components/@extended/AnimateButton';

// const dashImage = require.context('assets/images/landing', true);

// link - custom style
const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.primary.main
  },
  '&:active': {
    color: theme.palette.primary.main
  }
}));

// ==============================|| LANDING - FOOTER PAGE ||============================== //

const FooterBlock = ({ isFull }) => {
  const theme = useTheme();
  const { presetColor } = useConfig();
  // const textColor = theme.palette.mode === ThemeMode.DARK ? 'text.primary' : 'background.paper';
  let primaryColors = ['#D6E4FF', '#D6E4FF', '#ADC8FF', '#84A9FF', '#6690FF', '#3366FF', '#254EDB', '#1939B7', '#102693', '#102693'];
  const contrastText = '#fff';
  const textColor = {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    }
  const linkSX = {
    color: theme.palette.common.white,
    fontSize: '0.875rem',
    fontWeight: 400,
    opacity: '0.6',
    cursor: 'pointer',
    '&:hover': {
      opacity: '1'
    }
  };


  return (
    <>
      <Box sx={{ pt: isFull ? 0 : 10, pb: 10, bgcolor: '#262626' }}>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <motion.div
                initial={{ opacity: 0, translateY: 550 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  damping: 30
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 400, color: theme.palette.common.white }}>
                      PassionIT Tech is disrupting the accounting industry through innovation, automation and artifical intelligence.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <CardMedia component="img" image={imgfooterlogo} sx={{ width: 'auto' }} />
                  </Grid>
                </Grid>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={8}>
              <Grid container spacing={{ xs: 5, md: 2 }}>
                <Grid item xs={6} sm={3}>
                  <Stack spacing={{ xs: 3, md: 5 }}>
                    <Typography variant="h5" color={contrastText} sx={{ fontWeight: 500 }}>
                      Simple
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Stack spacing={{ xs: 3, md: 5 }}>
                    <Typography variant="h5" color={contrastText} sx={{ fontWeight: 500 }}>
                      Intelligent
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Stack spacing={{ xs: 3, md: 5 }}>
                    <Typography variant="h5" color={contrastText} sx={{ fontWeight: 500 }}>
                      Automated
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Stack spacing={{ xs: 3, md: 5 }}>
                    <Typography variant="h5" color={contrastText} sx={{ fontWeight: 500 }}>
                      Integrated
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Divider sx={{ borderColor: 'grey.700' }} />
      <Box
        sx={{
          py: 1.5,
          bgcolor: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[50] : theme.palette.grey[800]
        }}
      >
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <Typography variant="subtitle2" color="grey">
                © Made by PassionIT Tech
              </Typography>
            </Grid>
            {/*<Grid item xs={12} sm={4}>*/}
            {/*  <Grid container spacing={2} alignItems="center" sx={{ justifyContent: 'flex-end' }}>*/}
            {/*    <Grid item>*/}
            {/*      <Link underline="none" sx={linkSX}>*/}
            {/*        <CardMedia component="img" image={imgfootersoc1} />*/}
            {/*      </Link>*/}
            {/*    </Grid>*/}
            {/*    <Grid item>*/}
            {/*      <Link underline="none" sx={linkSX}>*/}
            {/*        <CardMedia component="img" image={imgfootersoc2} />*/}
            {/*      </Link>*/}
            {/*    </Grid>*/}
            {/*    <Grid item>*/}
            {/*      <Link underline="none" sx={linkSX}>*/}
            {/*        <CardMedia component="img" image={imgfootersoc3} />*/}
            {/*      </Link>*/}
            {/*    </Grid>*/}
            {/*  </Grid>*/}
            {/*</Grid>*/}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

FooterBlock.propTypes = {
  isFull: PropTypes.bool
};

export default FooterBlock;
